<template>
    <ValidationObserver ref="observer">
        <section class="padding-vertical-content mb-3 mb-lg-4" id="paso-6">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="mb-4 h3 text-uppercase">{{ $t('bases.resumen_compra') }}</div>
                        <div class="pt-1 mx-auto bg-light white-content">
                            <ResumenCompraComponent :items="[base.categoria_base]" :esMovil="esMovil"
                                v-on:isAccepted="conditions_accepted_handler" class="m-3">
                            </ResumenCompraComponent>
                        </div>
                        <div v-if="are_conditions_accepted">
                            <div v-if="formulario" id="formulario-compra" v-html="formulario"></div>
                            <div v-if="show" class="mt-4">
                                <button :disabled="!show" type="submit" name="button" :class="!esMovil ? 'button effect-button large-button' : 'button effect-button large-button w-100'"
                                    @click="cargarFormularioPago()">
                                    <span>{{ $t('bases.terminar') }}</span>
                                </button>
                            </div>
                        </div>
                        <b-card v-else bg-variant="info" style="margin: 20px">
                            <b-card-text>
                                {{ $t('bases.condiciones') }}
                            </b-card-text>
                        </b-card>
                    </div>
                </div>
            </div>
        </section>
    </ValidationObserver>
</template>

<script>
import ResumenCompraComponent from "@/components/frontend/bases/ResumenCompraComponent";

export default {
    props: ["base", "esMovil"],
    data() {
        return {
            formulario: null,
            are_conditions_accepted: false,
            show: true
        };
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        },
        lista_abonados() {
            return this.$store.getters.getListaAbonados;
        },
    },
    created() {
        this.base.categoria_base.indumentariasElegidas = this.base.indumentariasElegidas;
    },
    methods: {
        conditions_accepted_handler(value) {
            this.are_conditions_accepted = value;
        },
        cargarFormularioPago() {
            this.base["filters"] = {
                tid: this.configuracion.hash_teatro,
            };
            this.base["tid"] = this.configuracion.hash_teatro;

            this.$store.dispatch(this.config.getVuexAlias("back.formulario.pago.bases"), this.base).then(res => {
                if (res.data.formulario) {
                    this.formulario = res.data.formulario;
                } else {
                    this.$emit('terminado');
                }
                this.show = false;
            });      
        }
    },
    components: {
        ResumenCompraComponent
    },
};
</script>